

































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import Review from "@/api/Review";
import RenderStars from "@/components/Shared/RenderStars.vue";
import ReviewStatusView from "@/components/Dashboard/Review/ReviewStatusView.vue";
import ReviewRecommendView from "@/components/Dashboard/Review/ReviewRecommendView.vue";

@Component({
  components: {ReviewRecommendView, ReviewStatusView, RenderStars}
})
export default class ReviewSummaryView extends Vue {
  @Prop() private review!: Review;
  private showDetails = false;

  get image1Path() {
    if(this.review.image1) {
      if (this.review.image1.length > 0) {
        return "/media/evaluation/images/" + this.review.image1;
      }
    }
    return null
  }

  get image2Path() {
    if(this.review.image2) {
      if (this.review.image2.length > 0) {
        return "/media/evaluation/images/" + this.review.image2;
      }
    }
    return null
  }

  public getReviewToView() {
    if (this.$route.matched.some(({name}) => name === 'customer-review-view')) {
      if (this.review) {
        const reviewToViewId = parseInt(this.$route.params.reviewId);
        if (reviewToViewId == this.review.id) {
          this.showDetails = true;
          return;
        }
      }
    }
    this.showDetails = false;
  }

  mounted() {
    this.getReviewToView();
  }

  @Watch('$route')
  onRouteChanged() {
    this.getReviewToView();
  }
}
